module.exports = __webpack_public_path__ + "static/media/Knight-sword175_4c.b874db3e.svg";